import styled from 'styled-components';

export const Form = styled.form`
  height: 100%;
  flex: 1;
`;
